import React from 'react';
import './Hero.css';
import { ReactComponent as Vector1 } from '../../assets/vectors/LP-waitlist/Vector-1.svg';
import { ReactComponent as Vector2 } from '../../assets/vectors/LP-waitlist/Vector-2.svg';
import { ReactComponent as Vector3 } from '../../assets/vectors/LP-waitlist/Vector-3.svg';
import { ReactComponent as Vector4 } from '../../assets/vectors/LP-waitlist/Vector-4.svg';
import { ReactComponent as Vector } from '../../assets/vectors/LP-waitlist/Vector.svg';
// Note: image 88.svg is a large SVG moon image, so we import it as a ReactComponent for inline SVG or as an <img> if needed
import moonImg from '../../assets/vectors/LP-waitlist/image 86.svg';
import starFooterImg from '../../assets/images/Union.webp';

const Hero = () => (
  <section className="hero-section">
    <div className="hero-title-group">
    <h1 className="hero-title font-recoleta">
  Your Personal <br className="mobile-break" /> 
  Vedic Astrology <br className="desktop-break" /> 
  Guide, Completely Free
</h1>
      <div className='hero-subtitle-wrapper'>
        <div className="hero-subtitle">We have personalised your</div>
        <p className='hero-subtitle-tags'> Aaj ka Panchang, Aaj ki Rashifal, Graha Gochar Analysis, and Shubh Muhurat Planner.</p>
      </div>
      
      <button className="hero-main-btn" onClick={() => window.open('https://play.google.com/store/apps/details?id=com.astrology.mynaksh', '_blank')}>Download Now</button>
     
    </div>
    <div className="hero-moon-stack">
      <Vector1 className="hero-circular-bg hero-circular-bg-1" />
      <Vector2 className="hero-circular-bg hero-circular-bg-2" />
      <Vector3 className="hero-circular-bg hero-circular-bg-3" />
      <Vector4 className="hero-circular-bg hero-circular-bg-4" />
      <Vector className="hero-circular-bg hero-circular-bg-5" />
      <img src={moonImg} alt="Moon" className="hero-moon-img" />
    </div>
    
    <div className="hero-language-bar font-noto-sans">
      <div className="hero-language-main"><b>Personalised guidance - your culture, your language, your life.</b></div>
      <div className="hero-language-sub">Language options in native scripts like:</div>
      <div className="hero-language-list">
        <span className="lang-highlight">English</span> |
        <span className="lang-highlight"> हिंदी</span> |
        <span> தமிழ்</span> |
        <span> తెలుగు</span> |
        <span> ಕನ್ನಡ</span> |
        <span> বাংলা</span> |
        <span> മലയാളം</span>
      </div>

    </div>
    
    <div className="hero-footer-decor">
      <img src={starFooterImg} alt="Footer Decorative" className="hero-footer-star" />
    </div>
    <div className="shooting-star"></div>
    <div className="shooting-star"></div>
    <div className="shooting-star"></div>
    <div className="shooting-star"></div>
    <div className="shooting-star"></div>
    <div className="shooting-star"></div> {/* New star */}
    <div className="shooting-star"></div> {/* New star */}
    <div className="shooting-star"></div> {/* New star */}
    <div className="shooting-star"></div> {/* New star */}
    <div className="shooting-star"></div> {/* New star */}
  
  </section>
);

export default Hero;